import {Component} from '@angular/core';

@Component({
    selector: 'detail-body',
    imports: [],
    template: '<div class="detail-body-container"><ng-content/></div>',
    standalone: true,
    styles: [`
    .detail-body-container {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
  `]
})
export class DetailBodyComponent {

}
